
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { ServicesRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { DeleteServiceRequest } from "../../domain/requests/services/delete-service.request";

@Injectable({ providedIn: 'root' })
export class DeleteServiceUsecase implements UseCase<DeleteServiceRequest, boolean> {

  constructor(private readonly serviceRepository: ServicesRepository) {
  }

  execute(params: DeleteServiceRequest): Observable<boolean> {
    return this.serviceRepository.deleteService(params);
  }

}